import React, { Component } from 'react';

import ListaQrCode from './ListaQrCode';

import AuthProvider from '../../AuthProvider';

export default class extends Component {
  render() {
    return (
      <div>
        <AuthProvider>
          {(_undefined, containsRole) => {
            let children = [];

            if (
              containsRole([
                'admin',
                'conselheiro',
                'sindico'
              ])
            ) {
              children.push(ListaQrCode);
            }

            return 0 < children.length && children.map((Child, i) => (
              <Child key={i} />
            ));
          }}
        </AuthProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/agenda/IndexListaQrCode.js